/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import { Input, ModalHeader, ModalBody, ModalFooter, Button, Select, SelectItem, Divider, User } from '@nextui-org/react';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { getOnlyNumbers, formatNumericFields, fromPhotos, Constants, fromAssets } from '../../../utils';
import { IconImageEdit } from '../../../assets/icons';
import { IconPlus } from '@tabler/icons-react';
import { UsersService } from '../../../services';
import DebouncedSearch from '../../../components/input-debounce';
import * as moment from 'moment';
import CountryFlag from '../../../components/country-flag';


const ModalCreateParent = ({ user, onSuccess, onClose }) => {
  const [resetDebounce, setResetDebounce] = useState(false);
  const { addParent, form, onChange, onSubmit, parents, removeParent, phoneCodes, documentTypes, countries, genders, civilStatuses, schoolGrades, bloodTypes, relationships, currentUser, debounceValue, addPrevSchool, prevSchool, removePrevSchool, schoolYears } = useForm(user);

  const submit = async () => {
    const isSuccess = await onSubmit();
    if (isSuccess) onSuccess();
  }

  const searchResult = (item) => {
    if (!item) {
      onChange('', '_parentId')
      onChange('', '_parentDniType')
      onChange('', '_parentDni')
      onChange('', '_parentName')
      return;
    }
    onChange(item.id, '_parentId')
    onChange(item.document_type_id.toString(), '_parentDniType')
    onChange(getOnlyNumbers(item.document), '_parentDni')
    onChange(item.fullname, '_parentName')
  }

  const filterParents = async (query) => {
    const text = query.trim().toLowerCase();
    if (!text) return [];
    const response = await UsersService.school.findAll({ search: text, school_id: currentUser.id, level_id: Constants.USER.LEVELS.PARENT });
    const data = response.data.filter(item => !parents.find(x => x.id === item.id));
    return data;
  }

  const newParent = () => {
    setResetDebounce((prev) => !prev)
    addParent()
  }



  return (
    <>
      <ModalHeader className="flex flex-col gap-1">{!!user ? 'Editar' : 'Nuevo'}</ModalHeader>
      <ModalBody className="gap-8">
        <div className="flex items-center justify-start">
          <label htmlFor="photo" className="cursor-pointer text-center border-2 border-gray w-16 h-16 rounded-lg flex justify-center items-center self-center overflow-hidden">
            {!!form.photoUrl ? (
              <img className="w-full h-full object-cover" src={form.photoUrl} alt="Foto del colegio" />
            ) : (
              <img className="w-12 object-contain opacity-50" src={IconImageEdit} alt="Foto del colegio" />
            )}
            <input
              id="photo"
              type="file"
              accept="image/*"
              hidden
              onChange={e => onChange(e.target.files[0], 'photo')}
            />
          </label>

          <div className="flex flex-col ml-4 text-sm">
            <span className="font-medium leading-3">Subir foto de perfil</span>
            <span>(Tipo carnet y fondo gris)</span>
          </div>
        </div>

        <div className="flex flex-col flex-1 gap-4">
          <div className="grid grid-cols-4 gap-4">
            <Input
              label="Nombre"
              labelPlacement="outside"
              placeholder=" "
              radius="sm"
              variant="bordered"
              value={form.name}
              onValueChange={v => onChange(v, 'name')}
            />
            <Input
              label="Apellido"
              labelPlacement="outside"
              placeholder=" "
              radius="sm"
              variant="bordered"
              value={form.lastname}
              onValueChange={v => onChange(v, 'lastname')}
            />
            <Input
              label="DNI/C.I"
              labelPlacement="outside"
              placeholder=" "
              startContent={(
                <Select
                  aria-label="Tipo de documento"
                  variant="flat"
                  classNames={{ trigger: 'border-0 max-w-24' }}
                  disallowEmptySelection={true}
                  selectedKeys={!!form.document_type_id ? [form.document_type_id] : []}
                  onSelectionChange={v => onChange(v.currentKey, 'document_type_id')}
                >
                  {documentTypes.map((item) => (
                    <SelectItem key={item.value} value={item.value}>
                      {item.label}
                    </SelectItem>
                  ))}
                </Select>
              )}
              variant="bordered"
              radius="sm"
              classNames={{ innerWrapper: 'overflow-hidden', inputWrapper: 'pl-0' }}
              value={form.document}
              onValueChange={v => onChange(getOnlyNumbers(v), 'document')}
              maxLength={15}
            />
            <Select
              label="Género"
              labelPlacement="outside"
              placeholder=" "
              variant="bordered"
              radius="sm"
              classNames={{ label: 'font-semibold' }}
              disallowEmptySelection={true}
              selectedKeys={!!form.gender_id ? [form.gender_id] : []}
              onSelectionChange={v => onChange(v.currentKey, 'gender_id')}
            >
              {genders.map((item) => (
                <SelectItem key={item.value} value={item.value}>
                  {item.label}
                </SelectItem>
              ))}
            </Select>
          </div>

          <div className="grid grid-cols-4 gap-4">
            <Input
              label="Teléfono"
              labelPlacement="outside"
              placeholder=" "
              startContent={(
                <Select
                  aria-label="Código de área"
                  variant="flat"
                  classNames={{ trigger: 'border-0 max-w-28 pl-1 pr-0' }}
                  disallowEmptySelection={true}
                  selectedKeys={(!!form.phonecode_id && !!phoneCodes.length) ? [form.phonecode_id] : []}
                  onSelectionChange={v => onChange(v.currentKey, 'phonecode_id')}
                  startContent={<CountryFlag phoneCodeId={form.phonecode_id} phoneCodes={phoneCodes} />}
                >
                  {phoneCodes.map((item) => (
                    <SelectItem
                      key={item.value}
                      value={item.value}
                      startContent={<CountryFlag src={item.url} />}
                      classNames={{ title: 'min-w-48' }}
                    >
                      {item.label}
                    </SelectItem>
                  ))}
                </Select>
              )}
              variant="bordered"
              radius="sm"
              classNames={{ innerWrapper: 'overflow-hidden', inputWrapper: 'pl-0' }}
              value={form.phone}
              onValueChange={v => onChange(getOnlyNumbers(v), 'phone')}
              maxLength={12}
            />
            <Input
              label="Correo electrónico"
              labelPlacement="outside"
              placeholder=" "
              radius="sm"
              variant="bordered"
              value={form.email}
              onValueChange={v => onChange(v, 'email')}
            />
            <Select
              label="País"
              labelPlacement="outside"
              placeholder=" "
              variant="bordered"
              radius="sm"
              classNames={{ label: 'font-semibold' }}
              disallowEmptySelection={true}
              selectedKeys={!!form.country_id ? [form.country_id] : []}
              onSelectionChange={v => onChange(v.currentKey, 'country_id')}
            >
              {countries.map((item) => (
                <SelectItem key={item.value} value={item.value}>
                  {item.label}
                </SelectItem>
              ))}
            </Select>
            <Input
              label="Fecha de nacimiento"
              labelPlacement="outside"
              placeholder=" "
              radius="sm"
              variant="bordered"
              type="date"
              value={form.birthdate}
              onValueChange={v => onChange(v, 'birthdate')}
            />
          </div>

          <div className="grid grid-cols-4 gap-4">
            <Select
              label="Estado civil"
              labelPlacement="outside"
              placeholder=" "
              variant="bordered"
              radius="sm"
              classNames={{ label: 'font-semibold' }}
              disallowEmptySelection={true}
              selectedKeys={!!form.civil_status_id ? [form.civil_status_id] : []}
              onSelectionChange={v => onChange(v.currentKey, 'civil_status_id')}
            >
              {civilStatuses.map((item) => (
                <SelectItem key={item.value} value={item.value}>
                  {item.label}
                </SelectItem>
              ))}
            </Select>

            <Select
              label="Año escolar"
              labelPlacement="outside"
              placeholder=" "
              variant="bordered"
              radius="sm"
              classNames={{ label: 'font-semibold' }}
              disallowEmptySelection={true}
              selectedKeys={!!form.school_year_id ? [form.school_year_id] : []}
              onSelectionChange={v => onChange(v.currentKey, 'school_year_id')}
            >
              {schoolYears.map((item) => (
                <SelectItem key={item.value} value={item.value}>
                  {item.label}
                </SelectItem>
              ))}
            </Select>

            <Select
              label="Grado a cursar"
              labelPlacement="outside"
              placeholder=" "
              variant="bordered"
              radius="sm"
              classNames={{ label: 'font-semibold' }}
              disallowEmptySelection={true}
              selectedKeys={!!form.school_grade_id ? [form.school_grade_id] : []}
              onSelectionChange={v => onChange(v.currentKey, 'school_grade_id')}
            >
              {schoolGrades.map((item) => (
                <SelectItem key={item.value} value={item.value}>
                  {item.label}
                </SelectItem>
              ))}
            </Select>

            <Input
              label="Domicilio"
              labelPlacement="outside"
              className="col-span-2"
              placeholder=" "
              radius="sm"
              variant="bordered"
              value={form.address}
              onValueChange={v => onChange(v, 'address')}
            />
          </div>

          <Divider />

          <div>
            <h6 className="text-primary font-bold mb-2">Instituciones donde cursó estudios</h6>
            <div className="grid grid-cols-3 gap-4">

              <Input
                label="Nombre del colegio"
                labelPlacement="outside"
                placeholder=" "
                radius="sm"
                variant="bordered"
                value={form._school_name}
                onValueChange={v => onChange(v, '_school_name')}
              />

              <Input
                label="Localidad"
                labelPlacement="outside"
                placeholder=" "
                radius="sm"
                variant="bordered"
                value={form._school_locality}
                onValueChange={v => onChange(v, '_school_locality')}
              />

              <div className="flex items-end">
                <Button
                  isIconOnly
                  color="primary"
                  isDisabled={!form._school_name}
                  onPress={addPrevSchool}
                >
                  <IconPlus />
                </Button>
              </div>
            </div>
          </div>

          <div className="flex col-span-4 gap-4">
            {prevSchool.map((item, index) => (
              <div onClick={() => removePrevSchool(index)} className="flex flex-col shadow-sm py-2 px-4 cursor-pointer">
                <span className='capitalize text-sm font-bold'>{item.name}</span>
                {
                  !!item.locality &&
                  <span className="text-sm">({item.locality})</span>
                }
              </div>

            ))}
          </div>

          <Divider />


          <div>
            <h6 className="text-primary font-bold mb-2">Datos médicos</h6>
            <div className="grid grid-cols-4 gap-4">
              <Select
                label="Grupo sanguíneo"
                labelPlacement="outside"
                placeholder=" "
                variant="bordered"
                radius="sm"
                classNames={{ label: 'font-semibold' }}
                disallowEmptySelection={true}
                selectedKeys={!!form.blood_type_id ? [form.blood_type_id] : []}
                onSelectionChange={v => onChange(v.currentKey, 'blood_type_id')}
              >
                {bloodTypes.map((item) => (
                  <SelectItem key={item.value} value={item.value}>
                    {item.label}
                  </SelectItem>
                ))}
              </Select>
              <Input
                label="Condiciones especiales"
                labelPlacement="outside"
                placeholder=" "
                radius="sm"
                variant="bordered"
                value={form.special_conditions}
                onValueChange={v => onChange(v, 'special_conditions')}
              />
              <Input
                label="Alergias o contraindicaciones"
                labelPlacement="outside"
                placeholder=" "
                radius="sm"
                variant="bordered"
                value={form.allergies}
                onValueChange={v => onChange(v, 'allergies')}
              />
            </div>
          </div>

          <Divider />

          <div>
            <h6 className="text-primary font-bold mb-2">Representantes</h6>
            <div className="grid grid-cols-4 gap-4">
              <DebouncedSearch
                refresh={resetDebounce}
                label='Nombre'
                fetchFunction={filterParents}
                debounceTime={700}
                onSelect={searchResult}
                renderItem={(item) => (
                  <div>
                    <p>{item.fullname}</p>
                    <p>{item.document_type?.name}{item.document}</p>
                  </div>
                )}
                onClickLabel={(item) => item.fullname}
                value={debounceValue}
              />
              <Input
                label="DNI/C.I"
                labelPlacement="outside"
                placeholder=" "
                startContent={(
                  <Select
                    aria-label="Tipo de documento"
                    variant="flat"
                    classNames={{ trigger: 'border-0 max-w-24 h-10' }}
                    disallowEmptySelection={true}
                    selectedKeys={!!form._parentDniType ? [form._parentDniType] : []}
                    onSelectionChange={v => onChange(v.currentKey, '_parentDniType')}
                  >
                    {documentTypes.map((item) => (
                      <SelectItem key={item.value} value={item.value}>{item.label}</SelectItem>
                    ))}
                  </Select>
                )}
                variant="bordered"
                radius="sm"
                classNames={{ innerWrapper: 'overflow-hidden', inputWrapper: 'pl-0' }}
                value={form._parentDni}
                onValueChange={v => onChange(getOnlyNumbers(v), '_parentDni')}
                maxLength={15}
              />
              <Select
                label="Parentesco"
                labelPlacement="outside"
                placeholder=" "
                variant="bordered"
                radius="sm"
                classNames={{ label: 'font-semibold' }}
                disallowEmptySelection
                selectedKeys={!!form._parentRelationship ? [form._parentRelationship] : []}
                onSelectionChange={v => onChange(v.currentKey, '_parentRelationship')}
              >
                {relationships.map((item) => (
                  <SelectItem key={item.value} value={item.value}>{item.label}</SelectItem>
                ))}
              </Select>

              <div className="flex items-end">
                <Button
                  isIconOnly
                  color="primary"
                  isDisabled={!form._parentName || !form._parentDniType || !form._parentDni || !form._parentRelationship || parents.length >= 2}
                  onPress={newParent}
                >
                  <IconPlus />
                </Button>
              </div>
            </div>
          </div>

          <div className="flex col-span-4 gap-4">
            {parents.map((item, index) => (
              <User
                avatarProps={{ showFallback: true, radius: 'full' }}
                classNames={{ base: 'cursor-pointer', description: 'text-foreground-500' }}
                variant="bordered"
                name={item.name}
                description={`(${item.relationship})`}
                onClick={() => removeParent(index)}
              />
            ))}
          </div>

          <Divider />

        </div>
      </ModalBody>
      <ModalFooter>
        <Button variant="light" onPress={onClose}>Cerrar</Button>
        <Button className="bg-green" color="primary" onPress={submit}>Guardar</Button>
      </ModalFooter>
    </>
  )
}

const useForm = (currentUser) => {
  const initialForm = {
    photo: {},
    photoUrl: '',
    name: '',
    lastname: '',
    document_type_id: '',
    document: '',
    gender_id: '',
    phonecode_id: '',
    phone: '',
    email: '',
    country_id: '',
    birthdate: '',
    civil_status_id: '',
    school_year_id: '',
    school_grade_id: '',
    address: '',
    blood_type_id: '',
    special_conditions: '',
    allergies: '',
    representatives: [],
    _parentId: '',
    _parentName: '',
    _parentDniType: '',
    _parentDni: '',
    _parentRelationship: '',
    // Para registrar los colegios previos
    _school_name: '',
    _school_locality: '',
    hasFile: true,
  };
  const user = useSelector(state => state.user);
  const [form, setForm] = useState(initialForm);
  const [debounceValue, setDebounceValue] = useState('');
  const [prevSchool, setPrevSchool] = useState([]);
  const [parents, setParents] = useState([]);
  const [phoneCodes, setPhoneCodes] = useState([]);
  const [genders, setGenders] = useState([]);
  const [countries, setCountries] = useState([]);
  const [civilStatuses, setCivilStatuses] = useState([]);
  const [schoolGrades, setSchoolGrades] = useState([]);
  const [documentTypes, setDocumentTypes] = useState([]);
  const [bloodTypes, setBloodTypes] = useState([]);
  const [relationships, setRelationships] = useState([]);
  const [schoolYears, setSchoolYears] = useState([]);

  const onChange = (value, target) => {
    if (target === 'photo' && !!value) {
      setForm(s => ({ ...s, photoUrl: URL.createObjectURL(value) }));
    }

    setForm(s => ({ ...s, [target]: value }));
  }

  const addParent = () => {
    const relationship = relationships.find(x => x.value === form._parentRelationship)?.label;
    setParents([
      ...parents,
      {
        id: form._parentId,
        name: form._parentName,
        dni: `${form._parentDniType}${form._parentDni}`,
        relationship_id: Number(form._parentRelationship),
        relationship,
      }
    ]);
    setDebounceValue('');
    setForm(s => ({
      ...s,
      _parentName: '',
      _parentDniType: '',
      _parentDni: '',
      _parentRelationship: '',
    }));
  }

  const addPrevSchool = () => {
    setPrevSchool([
      ...prevSchool,
      {
        name: form._school_name,
        locality: form._school_locality,
      }
    ]);
    setForm(s => ({
      ...s,
      _school_name: '',
      _school_locality: '',
    }));
  }

  const removeParent = (index) => {
    setParents(parents.filter((_, idx) => index !== idx));
  }

  const removePrevSchool = (index) => {
    setPrevSchool(prevSchool.filter((_, idx) => index !== idx));
  }

  const onError = (msg) => {
    toast.error(msg);
    return false;
  }

  const getSelects = async () => {
    const toSelect = (items) => items.map(x => ({ ...x, value: String(x.id), label: x.name }));
    const toSelectCodePhone = (items) => items.map(x => ({ ...x, value: String(x.id), label: x.name, url: x.url }));

    try {
      const selects = await UsersService.school.getSelects({ user_id: user.id });
      setPhoneCodes(toSelectCodePhone(selects.phonecodes));
      setCountries(toSelect(selects.countries));
      setDocumentTypes(toSelect(selects.document_types));
      setGenders(toSelect(selects.genders));
      setCivilStatuses(toSelect(selects.civil_statuses));
      setSchoolGrades(toSelect(selects.school_grades));
      setBloodTypes(toSelect(selects.blood_types));
      setRelationships(toSelect(selects.reperesentative_relationships));
      setSchoolYears(toSelect(selects.school_years));

    } catch (error) {
      toast.error(String(error) || 'Ocurrió un error inesperado');
      return false;
    }
  }

  const isValidForm = () => {
    if (!form.name)
      return onError('Debe indicar el nombre del estudiante');

    if (!form.lastname)
      return onError('Debe indicar el apellido del estudiante');

    if (!form.document_type_id)
      return onError('Debe indicar el tipo de documento');

    if (!form.document)
      return onError('Debe indicar el número de documento');

    if (!form.gender_id)
      return onError('Debe indicar el género')

    if (!form.phonecode_id)
      return onError('Debe indicar el código de área');

    if (!form.phone)
      return onError('Debe indicar el número telefónico');

    if (!form.email)
      return onError('Debe indicar el correo');

    if (!form.country_id)
      return onError('Debe indicar el país')

    if (!form.birthdate)
      return onError('Debe indicar la fecha de nacimiento')

    if (moment(form.birthdate).isAfter(moment()))
      return onError('La fecha de nacimiento no puede ser mayor a la actual')

    if (!form.civil_status_id)
      return onError('Debe indicar el estado civil')

    if (!form.school_grade_id)
      return onError('Debe indicar el grado a cursar')

    if (!form.address)
      return onError('Debe indicar la dirección')

    if (parents.length < 1)
      return onError('Debe seleccionar al menos un representante')

    if (parents.length > 2)
      return onError('Sólo puede agregar un máximo de dos representantes')

    return true;
  }

  const onSubmit = async () => {
    if (!isValidForm()) return;
    try {
      let numericFields = ['civil_status_id', 'country_id', 'document_type_id', 'gender_id', 'phonecode_id', 'school_grade_id']
      const formattedData = formatNumericFields(form, numericFields);
      const data = { ...formattedData, school_id: user.id, prevSchool: prevSchool.map((x) => JSON.stringify(x)) }
      currentUser
        ? await UsersService.school.updateStudent({ ...data, id: currentUser.id })
        : await UsersService.school.createStudent(data);
      toast.success(`Usuario ${currentUser ? 'editado' : 'creado'} correctamente`);
      return true;

    } catch (error) {
      onError(String(error));
      return false;
    }
  }

  useEffect(() => {
    if (!!currentUser) {
      setForm({
        photo: {},
        photoUrl: !!currentUser?.photo ? fromPhotos(currentUser.photo) : '',
        name: currentUser?.name,
        lastname: currentUser?.lastname,
        document_type_id: String(currentUser?.document_type_id || ''),
        document: currentUser?.document,
        gender_id: String(currentUser?.gender_id || ''),
        phonecode_id: String(currentUser?.phonecode_id || ''),
        phone: currentUser?.phone,
        email: currentUser?.email,
        country_id: String(currentUser?.country_id || ''),
        birthdate: currentUser?.birthdate,
        civil_status_id: String(currentUser?.civil_status_id || ''),
        school_year_id: String(currentUser?.school_grade?.school_year_id || ''),
        school_grade_id: String(currentUser?.school_grade_id || ''),
        address: currentUser?.address,
        blood_type_id: String(currentUser?.blood_type_id || ''),
        special_conditions: currentUser?.special_conditions,
        allergies: currentUser?.allergies,
        hasFile: true,
        representatives: [], // se rellena más abajo
      });

      if (currentUser.representatives?.length > 0) {
        setParents(currentUser.representatives.map(x => ({
          id: x.parent.id,
          name: x.parent.fullname,
          dni: `${x.parent.document_type?.name}${x.parent.document}`,
          relationship_id: x?.relationship_id,
          relationship: x?.relationship?.name || 'Sin relación',
        })));
      }

      if (currentUser.prevSchool?.length > 0) {
        setPrevSchool(currentUser.prevSchool.map(x => ({
          name: x.name,
          locality: x.locality,
        })));
      }
    }
  }, [currentUser]);

  useEffect(() => {
    const parentsData = parents.map((x) => JSON.stringify({ user_id: x.id, relationship_id: x.relationship_id }));
    setForm(s => ({ ...s, representatives: parentsData }));
  }, [parents])

  useEffect(() => {
    getSelects();
  }, []);

  return {
    addParent,
    form,
    onChange,
    onSubmit,
    parents,
    removeParent,
    phoneCodes,
    countries,
    genders,
    civilStatuses,
    schoolYears,
    schoolGrades: schoolGrades.filter(x => +x.school_year_id === +form.school_year_id),
    documentTypes,
    bloodTypes,
    relationships,
    currentUser: user,
    debounceValue,
    addPrevSchool,
    prevSchool,
    removePrevSchool,
  }
}

export default ModalCreateParent;

